const wait = (delay: number) => new Promise((resolve) => setTimeout(resolve, delay));

export const fetchRetry = async (url: RequestInfo | URL, options: RequestInit, n = 3): Promise<Response> => {
    try {
        return await fetch(url, options);
    } catch (err) {
        if (n === 1) throw err;
        return wait(Math.floor(Math.random() * 1000)).then(() => fetchRetry(url, options, n - 1));
    }
};
